import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Native BankID does not use an OAuth /callback round-trip (that was the Criipto
// flow, now removed). Any hit to /callback just returns home.
const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
};

export default Callback;
